/**
 * Labstep
 *
 * @module core/Form/Reusable/Group
 * @desc Form group to submit multiple forms
 */

import { Button } from 'labstep-web/core/Button';
import { Flex } from 'labstep-web/core/Flex';
import { FormReusable } from 'labstep-web/core/Form/Reusable';
import type React from 'react';
import { useState } from 'react';
import type { IFormReusableProps } from '../types';
import type { IFormReusableGroupProps } from './types';

export const FormReusableGroup: React.FC<IFormReusableGroupProps> = ({
  onSubmit,
  addAnother = true,
  ...rest
}) => {
  const [count, setCount] = useState(0);
  const onSubmitWithReset: IFormReusableProps['onSubmit'] = (
    values,
  ) => {
    onSubmit(values);
    setCount(count + 1);
  };

  const submitButton: React.FC<{ submitForm: VoidFunction }> = ({
    submitForm,
  }) => (
    <Flex>
      {addAnother && (
        <Button primary basic type="submit" children="Add another" />
      )}
      <Button
        primary
        type="button"
        children="Done"
        onClick={(): void => {
          submitForm();
        }}
      />
    </Flex>
  );

  return (
    <FormReusable
      key={String(count)}
      onSubmit={onSubmitWithReset}
      submitButton={submitButton}
      {...rest}
    />
  );
};
